import React from 'react';
import { BasicMetrics } from '../../../../types/dashboard.types';
import {
  InboxIcon,
  TruckIcon,
  CalendarIcon,
  AlertTriangleIcon,
} from '../../../components/ui/Icons';
import styles from './KpiCards.module.css';

interface KpiCardsProps {
  metrics?: BasicMetrics;
}

const KpiCards: React.FC<KpiCardsProps> = ({ metrics }) => {
  const items = [
    {
      label: 'Total Loads',
      value: metrics?.totalLoads ?? 0,
      icon: <InboxIcon size={22} />,
      color: '#00827e',
    },
    {
      label: 'Active Loads',
      value: metrics?.activeLoads ?? 0,
      icon: <TruckIcon size={22} />,
      color: '#f7941e',
    },
    {
      label: "Today's Loads",
      value: metrics?.todayLoads ?? 0,
      icon: <CalendarIcon size={22} />,
      color: '#009ce0',
    },
    {
      label: 'Critical Loads',
      value: metrics?.criticalLoads ?? 0,
      icon: <AlertTriangleIcon size={22} />,
      color: '#ef5350',
    },
  ];

  return (
    <div className={styles.grid}>
      {items.map((item) => (
        <div
          key={item.label}
          className={styles.card}
          style={{ ['--kpi-border' as any]: item.color }}
        >
          <span className={styles.iconBox} style={{ background: item.color }}>
            {item.icon}
          </span>
          <div className={styles.body}>
            <span className={styles.label}>{item.label}</span>
            <span className={styles.sep}>|</span>
            <span className={styles.value} style={{ color: item.color }}>
              {item.value}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default KpiCards;
